var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-copied"},[_c('SuccessIcon',{attrs:{"className":"status-copied-success-icon"}}),_vm._v("\n  Copied\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }